(function() {
  var activeDragContainer = null;
  var DRAG_THRESHOLD = 6;

  function isRtlScrollContainer(container) {
    return getComputedStyle(container).direction === 'rtl';
  }

  function bindDragEndOnce() {
    if (document.documentElement.dataset.horizontalScrollTabsDragBound === 'true') return;
    document.documentElement.dataset.horizontalScrollTabsDragBound = 'true';

    function resetDrag() {
      if (!activeDragContainer) return;
      activeDragContainer._hstDragIsDown = false;
      activeDragContainer.classList.remove('is-dragging');
      activeDragContainer.style.cursor = '';
      activeDragContainer = null;
    }

    document.addEventListener('mouseleave', resetDrag);
    document.addEventListener('mouseup', resetDrag);
  }

  function bindHorizontalScrollTabs(container) {
    if (!container || container.dataset.horizontalScrollTabsBound === 'true') return;
    container.dataset.horizontalScrollTabsBound = 'true';
    bindDragEndOnce();

    container.addEventListener('wheel', function(event) {
      if (container.scrollWidth <= container.clientWidth) return;
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      var delta = event.deltaY;
      if (isRtlScrollContainer(container)) delta = -delta;
      container.scrollLeft += delta;
      event.preventDefault();
    }, { passive: false });

    container.addEventListener('mousedown', function(event) {
      if (event.target.closest('button, a, input, label, select, textarea')) return;
      activeDragContainer = container;
      container._hstDragIsDown = true;
      container._hstDragDidDrag = false;
      container._hstDragStartX = event.pageX;
      container._hstDragStartScrollLeft = container.scrollLeft;
    });

    container.addEventListener('mousemove', function(event) {
      if (!container._hstDragIsDown) return;
      var dx = event.pageX - container._hstDragStartX;
      if (!container._hstDragDidDrag && Math.abs(dx) > DRAG_THRESHOLD) {
        container._hstDragDidDrag = true;
        container.classList.add('is-dragging');
        container.style.cursor = 'grabbing';
      }
      if (container._hstDragDidDrag) {
        event.preventDefault();
        var walk = (event.pageX - container._hstDragStartX) * 1.5;
        if (isRtlScrollContainer(container)) {
          container.scrollLeft = container._hstDragStartScrollLeft + walk;
        } else {
          container.scrollLeft = container._hstDragStartScrollLeft - walk;
        }
      }
    });

    container.addEventListener('click', function(event) {
      if (container._hstDragDidDrag) {
        event.preventDefault();
        event.stopPropagation();
        window.setTimeout(function() {
          container._hstDragDidDrag = false;
        }, 0);
      }
    }, true);
  }

  function scrollActiveTabIntoView(container) {
    if (!container) return;
    var active = container.querySelector('.new-collection-tabs__item--active, .new-collection-tabs__item.is-active');
    if (!active) return;
    active.scrollIntoView({
      behavior: 'auto',
      block: 'nearest',
      inline: isRtlScrollContainer(container) ? 'start' : 'nearest'
    });
  }

  function initHorizontalScrollTabs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-horizontal-scroll-tabs]').forEach(function(container) {
      bindHorizontalScrollTabs(container);
      scrollActiveTabIntoView(container);
    });
  }

  window.initHorizontalScrollTabs = initHorizontalScrollTabs;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initHorizontalScrollTabs(document);
    });
  } else {
    initHorizontalScrollTabs(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initHorizontalScrollTabs(event.target);
  });
})();
